import {createContext, use} from 'react'

export const ExpandedRowsContext = createContext<{
  /**
   * Returns the expanded row IDs array for the current view.
   */
  expandedRows: Array<string>
  /**
   * Returns the expanded row IDs for a specific view number.
   */
  getExpandedRowsForView: (viewNumber: number) => Array<string>
  /**
   * Toggles the expanded state of a row for the current view by its ID.
   */
  toggleRowExpanded: (rowId: string) => void
  /**
   * Returns `true` if the given row ID is expanded in the current view, returns `false` otherwise.
   */
  isRowExpanded: (rowId: string) => boolean
  /**
   * Returns `true` if the given row ID is expanded in the specified view number, returns `false` otherwise.
   */
  isRowExpandedForView: (viewNumber: number, rowId: string) => boolean
} | null>(null)

export const useExpandedRows = () => {
  const ctx = use(ExpandedRowsContext)
  if (!ctx) throw new Error('useExpandedRows must be used within a ExpandedRowsContext')
  return ctx
}
